import { getField, updateField } from "vuex-map-fields";
import router from "../../../router";
const timerSeconds = 60;
let tid = new Object();

const getDefaultState = () => {
  return {
    SSInfogetCertMotpBizDscd: "", // nLogin, Login, push
    pushMotpId: "",
    valdnId: "", //생체정보검증ID
    alamDsticCd: "", //생체검증취소 push
    isOpenMotpIssue: false,
    Toast: {
      isOpen: false,
      contents: "",
    },
    AuthModal: {
      isOpen: false,
      contents: "",
    },
    /**
     * 기기 mOTP 데이터 목록(app데이터 + server데이터 )
     */
    SSInfogetMotpServer: {
      in: {
        appData: [
          // {
          // 	strUserId: "G21000009100000"
          // , secret: "dfefewfsdfadsafasdfasdfsdf...."
          // }
        ],
        smphMchtlUniqNo: "",
        operGroupCd: "",
        siteCode: "",
      },
      out: {
        success: {
          appServerList: [
            // 아래 참고..
          ],
          systemId: "",
        },
        fail: {},
      },
    },
    /**
     * 선택된 mOTP 정보
     */
    selectedMotp: {
      operGroupCd: "", //	운영그룹코드
      iD: "", //	ID
      otpStusDstcd: "", //	OTP상태구분코드
      coprPpsnDstcd: "", //	법인개인구분코드
      cin: "", //	고객정보번호
      wWWBnkgLginID: "", //	인터넷뱅킹로그인ID
      mchtlUniqNo: "", //	기기고유번호
      pinFailNotms: 0, //	핀실패횟수
      certnErrNotms: 0, //	인증오류횟수
      totalCertnSucssNotms: 0, //	총인증성공횟수
      totalCertnErrNotms: 0, //	총인증오류횟수
      frstCertnSucssLcalYMS: "", //	최초인증성공현지일시
      lastCertnDmndLcalYMS: "", //	최종인증요청현지일시
      lastCertnSucssLcalYMS: "", //	최종인증성공현지일시
      lastCertnErrLcalYMS: "", //	최종인증오류현지일시
      issuncLcalYMS: "", //	발급현지일시
      frstCertnSucssYMS: "", //	최초인증성공일시
      lastCertnDmndYMS: "", //	최종인증요청일시
      lastCertnSucssYMS: "", //	최종인증성공일시
      lastCertnErrYMS: "", //	최종인증오류일시
      issuncYMS: "", //	발급일시
      smphMchtlUniqNo: "", //	스마트폰기기고유번호
      smphMchtlDstcd: "", //	스마트폰기기구분코드
      pgmVsnno: "", //	프로그램버전번호
      certnDmndCd: "", //	인증요청코드
      smphMdelName: "", //	스마트폰모델명
      writYMS: "", //	작성일시
      lastAmndYMS: "", //	최종수정일시
      rmark: "", //	비고
      lastAcidntYMS: "", //	최종사고신고일시
    },
    /**
     * APP 인증코드 콜백데이터
     */
    SSGenerateMotpForPC: {
      result: "", // 결과코드
      motp: "", // mOTP난수
      errorcode: "", // 에러코드
      failcount: "", // mPin 오류횟수
    },
    /**
     * 인증코드 입력 남은 시간
     */
    sendTime: 0,
    updateMpinErr: {
      in: {
        iD: "",
      },
      out: {
        success: {},
        fail: {},
      },
    },
  };
};

const authPCMotp = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getSSInfogetMotpServer: state => {
      return state.SSInfogetMotpServer;
    },
    getSelectedMotp: state => {
      return state.selectedMotp;
    },
    getSSGenerateMotpForPC: state => {
      return state.SSGenerateMotpForPC;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    mut001: function (state, payload) {
      state.SSInfogetMotpServer.in.appData = [];
      payload.Motpinfo.length > 0 &&
        payload.Motpinfo.forEach(e => {
          state.SSInfogetMotpServer.in.appData.push(e);
        });
    },
    mut002: function (state, payload) {
      this._vm.$set(state.selectedMotp, payload.key, payload.value);
    },
    mut003: function (state, payload) {
      this._vm.$set(state.SSGenerateMotpForPC, payload.key, payload.value);
    },
    mut005: state => {
      Object.assign(state.SSGenerateMotpForPC, getDefaultState().SSGenerateMotpForPC);
    },
  },
  actions: {
    /**
     * mOTP 목록 조회 - 비로그인 거래
     */
    act001: function (context) {
      return new Promise(resolve => {
        context.state.SSInfogetMotpServer.in.smphMchtlUniqNo = this.state.native.smphMchtlUniqNo;
        context.state.SSInfogetMotpServer.in.operGroupCd = this.state.operGroupCd;
        context.state.SSInfogetMotpServer.in.siteCode = this.state.siteCode;
        this._vm.$post(
          "/auth/motp/certn/SSInfogetMotpServer",
          context.state.SSInfogetMotpServer.in,
          response => {
            this._vm.$set(this.state.auth.authPCMotp.SSInfogetMotpServer.out, "success", response);
            if (context.state.SSInfogetCertMotpBizDscd === "Login") {
              context.dispatch("act008", this.getters["getMotpId"]);
            }

            if (context.state.SSInfogetCertMotpBizDscd === "push") {
              context.dispatch("act008", context.state.pushMotpId);
            }
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.authPCMotp.SSInfogetMotpServer.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * mOTP PC인증 app 호출 성공시..
     * 실패횟수가 4회 이하인 경우 - 인증번호 팝업을 열고, 타이머 초기화..
     * 실패횟수가 5회 이상인 경우 - mOTP상태코드 변경.
     */
    act002: function (context, payload) {
      this.state.auth.authPCMotp.sendTime = timerSeconds;
      clearInterval(tid);

      if (payload === "SUCCESS") {
        this.state.auth.authPCMotp.AuthModal.isOpen = true;
        context.dispatch("act003");
      }

      if (payload === "ERROR" && Number(this.state.auth.authPCMotp.SSGenerateMotpForPC.failcount) >= 5) {
        this.state.auth.authPCMotp.AuthModal.isOpen = false;
        context.dispatch("act006");
      }
    },
    /**
     * 인증코드 화면노출 타이머
     */
    act003: function (context) {
      tid = setInterval(() => {
        this.state.auth.authPCMotp.sendTime--;
        if (this.state.auth.authPCMotp.sendTime === 0) {
          clearInterval(tid);
          context.commit("mut005");
          // 최초 이후 인증번호 받아오는 경우.(native 키패드 열림 없음)
          context.dispatch("act004", "SSGenerateMotp_ReGenerate");
        }
      }, 1000);
    },
    /**
     * native bridge call
     */
    act004: function (context, payload) {
      switch (payload) {
        case "SSGenerateMotp_ReGenerate":
          this._vm.$bridge.SSGenerateMotp_ReGenerate({
            strUserId: this.state.auth.authPCMotp.selectedMotp.iD,
            strPeriod: "1",
            strSystemId: this.state.auth.authPCMotp.SSInfogetMotpServer.out.success.systemId,
          });
          break;
      }
    },
    /**
     * 타이머 초기화..
     */
    act005: function () {
      this.state.auth.authPCMotp.AuthModal.isOpen = false;
      this.state.auth.authPCMotp.sendTime = timerSeconds;
      clearInterval(tid);
    },
    /**
     * mPin오류누적(5회) 데이터 업데이트
     */
    act006: function (context) {
      return new Promise(resolve => {
        this.state.auth.authPCMotp.updateMpinErr.in.iD = this.state.auth.authPCMotp.selectedMotp.iD;

        this._vm.$post(
          "/auth/motp/certn/updateMpinErr",
          context.state.updateMpinErr.in,
          response => {
            router.push({ name: "authPCMotpStep1" });
            this._vm.$set(this.state.auth.authPCMotp.updateMpinErr.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(this.state.auth.authPCMotp.updateMpinErr.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * SSInfogetCertMotp bridge call
     * @param {*} context
     * @param {*} payload
     */
    act007: function (context, payload) {
      context.state.SSInfogetCertMotpBizDscd = "";
      if (payload === "") {
        this._vm.$log.info("SSInfogetCertMotpBizDscd is null!!!");
      }
      context.state.SSInfogetCertMotpBizDscd = payload;
      // brige -> SSInfogetMotp_callback_cert -> app.$store.dispatch("auth/authPCMotp/act001") -> app.$store.dispatch("auth/authPCMotp/act008");
      this._vm.$bridge.SSInfogetCertMotp();
    },
    /**
     * 로그인 인 경우 or push로 온경우
     */
    act008: function (context, payload) {
      const motpInfo = context.state.SSInfogetMotpServer.out.success.appServerList.filter(i => i.iD === payload)[0];
      if (!_.isNil(motpInfo) && !_.isNil(motpInfo.iD)) {
        for (let key in motpInfo) {
          context.commit("mut002", { key: key, value: motpInfo[key] });
        }

        // this._vm.$log.info("selectedMotp >>> " + JSON.stringify(context.state.selectedMotp, null, 2));

        if (context.state.selectedMotp.otpStusDstcd === "030") {
          router.push({ name: "authPCMotpStep2" }); // 정상인 경우
        } else if (context.state.selectedMotp.otpStusDstcd === "140") {
          router.push({ name: "authPCMotpStep3" }); // (인증번호)오류횟수초과,
        } else if (context.state.selectedMotp.otpStusDstcd === "150") {
          router.push({ name: "authPCMotpStep5" }); //mpin오류횟수초과
        } else if (context.state.selectedMotp.otpStusDstcd === "130" || context.state.selectedMotp.otpStusDstcd === "131") {
          if (context.state.selectedMotp.smphMchtlUniqNo === this.state.native.smphMchtlUniqNo) {
            router.push({ name: "authPCMotpStep6" }); // mOTP폐기(Token OTP 사용)
          } else {
            router.push({ name: "authPCMotpStep4" }); // mOTP폐기(사용 단말기 변경)
          }
        }
      } else {
        context.state.SSInfogetMotpServer.out.success.appServerList = [];
        router.push({ name: "authPCMotpStep1" });
      }
    },
    /**
     * pushCall
     * @param {*} context
     * @param {*} payload
     */
    act009: async function (context, payload) {
      const siteCode = payload.bizParam.siteCode;
      await this.dispatch("ACT_EXEC_LOGOUT", null, { root: true });
      this.commit("setSiteCode", { siteCode: siteCode, isLogin: false });
      this.commit("setMenu", siteCode);

      context.state.pushMotpId = payload.bizParam.mOtpId;
      this.dispatch("auth/authPCMotp/act007", "push");
    },
    /**
     * pushCall(생체정보검증)
     * @param {*} context
     * @param {*} payload
     */
    act010: async function (context, payload) {
      const siteCode = payload.bizParam.siteCode;
      if (payload.bizParam.alamDsticCd === "1") {
        context.state.alamDsticCd = payload.bizParam.alamDsticCd;
        // 생체정보검증취소알림
        if (payload.bizParam.nativYn === "1") {
          //내국인일때 내국인 생체정보 등록 화면으로 이동
          router.push({ name: "createEkycEnter" });
        } else {
          //외국인일때 외국인 생체정보 등록 화면으로 이동
          router.push({ name: "createForgnEkycEnter" });
        }
      } else {
        await this.dispatch("ACT_EXEC_LOGOUT", null, { root: true });
        this.commit("setSiteCode", { siteCode: siteCode, isLogin: false });
        this.commit("setMenu", siteCode);

        context.state.valdnId = payload.bizParam.valdnId;
        router.push({
          name: "lvbdInfoValdnPushPage",
          params: { valdnId: payload.bizParam.valdnId, nativYn: payload.bizParam.nativYn, lvbdCertnUniqID: payload.bizParam.lvbdCertnUniqID, baseUrl: payload.bizParam.baseUrl },
        });
      }
    },
  },
};

export default authPCMotp;

/**
 	ErrmsgErrcd: "",
	OutptLangDstcd: "",
	CustGuidLinkURL: "",
	ErrmsgErrSituNo: "",
	CustGuidLinkURLCtnt: "",
	ErrmsgTreatCd: "",
	Clear: "",
	ErrmsgErrPgmName: "",
	Type: "",
	TreatDesc: "",
	Trancode: "",
	ErrmsgOutptCstzMsgCtnt: "",
	MapngDstcd: "",
	Subtype: ""
 */
